<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({ report: { type: Array, required: true } });
defineEmits(['retry']);
const { t } = useI18n();

const GROUPS = ['needs_action', 'failed', 'created', 'skipped'];
const groups = computed(() =>
  GROUPS.map(status => ({
    status,
    items: props.report.filter(item => item.status === status),
  })).filter(group => group.items.length)
);
const hasFailed = computed(() => props.report.some(i => i.status === 'failed'));
</script>

<template>
  <div class="flex flex-col gap-4">
    <section v-for="group in groups" :key="group.status">
      <h4 class="mb-1 text-sm font-medium text-n-slate-12">
        {{
          t(`REVENDA.TEMPLATES.REPORT.${group.status.toUpperCase()}`, {
            count: group.items.length,
          })
        }}
      </h4>
      <ul class="flex flex-col gap-1">
        <li
          v-for="item in group.items"
          :key="item.item_key"
          class="text-sm text-n-slate-11"
        >
          <span class="font-medium text-n-slate-12">{{ item.name }}</span>
          <span class="ml-1 text-xs text-n-slate-10">{{
            t(`REVENDA.TEMPLATES.KINDS.${item.kind.toUpperCase()}`)
          }}</span>
          <p v-if="item.message" class="text-xs">{{ item.message }}</p>
        </li>
      </ul>
    </section>
    <Button
      v-if="hasFailed"
      data-test="retry-failed"
      :label="t('REVENDA.TEMPLATES.REPORT.RETRY')"
      @click="$emit('retry')"
    />
  </div>
</template>
